import React from 'react'
import { Box, Text } from 'grommet'
import styled from 'styled-components'
// import { rgba } from "polished"
import SpinningWheelLogo from './SpinningWheelLogo'

const Container = styled(Box)`
  background-color: ${props => props.theme.global.colors.backdrop};
  z-index: 1000002;
  position: fixed;
  top: 0;
  left: 0;
`

const SpinnerFullScreen = ({ caption, ...props }) => {
  return (
    <Container
      alignSelf="stretch"
      fill
      align="center"
      justify="center"
      gap="1.5rem"
    >
      <SpinningWheelLogo {...props} />
      <Text color="white">{caption}</Text>
    </Container>
  )
}

export default SpinnerFullScreen
